export const SEARCH_TYPE_VALUES = ['card', 'apple', 'google', 'externalId'] as const
export type SearchType = (typeof SEARCH_TYPE_VALUES)[number]
export function isSearchType(text: string): text is SearchType {
  return (SEARCH_TYPE_VALUES as readonly string[]).includes(text)
}